import animateOnScroll from "./animateOnScroll"
import Glide from '@glidejs/glide'
//animate elements
/*---------------
Notes
-----------------
Offset:
- .5 means half of the element is visible before triggering
- 1 means 100% of the element should be visible
- 0 would be if any part of the element is visible 
CSS animations:
- make sure that the transformX/Y is not too large otherwise it will take forever to animate in
*/
animateOnScroll([
    { selector: ".number", offset: 0.25, multiple: true },

]);


if (document.querySelector('#QuotesGlide')) {
    const el = document.querySelector('#QuotesGlide');
    const quoteSlider = new Glide(el, {
        type: 'carousel',
        perView: 1,
    });
    quoteSlider.mount();
}

if (document.querySelector('#NewsGlide')) {
    const el = document.querySelector('#NewsGlide');
    const newsSlider = new Glide(el, {
        type: 'carousel',
        perView: 3,
        breakpoints: {
            992: {
                perView: 2
            },
            576: {
                perView: 1
            },
        }
    });
    newsSlider.mount();
}

if (document.querySelector('#LogoGlide')) {
    const el = document.querySelector('#LogoGlide');
    const logoSlider = new Glide(el, {
        type: 'carousel',
        autoplay: 1,
        animationDuration: 5000,
        animationTimingFunc: 'linear',
        perView: 7,
        breakpoints: {
            992: {
                perView: 3
            },
            576: {
                perView: 2
            },
        }
    });
    logoSlider.mount();
}